import type { PropertySelectionItem } from "libs/codegen/homes-onbaording";
import { PropertySelectionStatus } from "./constants";

export const fromUrlFirstSorter = (a: PropertySelectionItem, b: PropertySelectionItem) => {
    // if item status is ImportableFromRoomUrl, then it should be on top
    if (
        a.status === PropertySelectionStatus.ImportableFromRoomUrl &&
        b.status !== PropertySelectionStatus.ImportableFromRoomUrl
    )
        return -1;

    return 0;
};
